import { ref } from "vue";
import type { IGroup } from "@/scripts/application/types";

export const groups = ref<IGroup[]>([]);
export const orderLoading = ref(false);
